<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="container">
            <nav-bar-box :extr="navData"></nav-bar-box>
            <section v-if="listData.length > 0">
                <div class="list_box1">
                    <!-- <h4>原材成本汇总表</h4> -->
                    <table border>
                        <thead>
                            <tr class="head_tr">
                                <th class="tr_one" style="width: 34%;">
                                    品种
                                </th>
                                <th style="width: 22%;">
                                    入库数量
                                    <br>
                                    (吨)
                                </th>
                                <th style="width: 22%;">
                                    出库数量
                                    <br>
                                    (吨)
                                </th>
                                <th style="width: 22%;">
                                    当日库存
                                    <br>
                                    (吨)
                                </th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="list_box">
                    <!-- <h4>原材成本汇总表</h4> -->
                    <table border>
                        <tbody class="table_body_box">
                            <template v-for="(item, index) in listData">
                                <tr :key="`cost_${index}`" :class="{tr_shallow: index % 2 === 0, tr_deep: index % 2 !== 0}">
                                    <td align="center" style="width: 34%;">
                                        <span>{{ item.group_name }}</span>
                                    </td>
                                    <td align="center" style="width: 22%;">
                                        <span>{{ item.current_inbound }}</span>
                                    </td>
                                    <td align="center" style="width: 22%;">
                                        <span>{{ item.current_outbound }}</span>
                                    </td>
                                    <td align="center" style="width: 22%;">
                                        <span>{{ item.current_stock }}</span>
                                    </td>
                                </tr>
                            </template>
                            <div class="border_div"></div>
                        </tbody>
                    </table>
                </div>
            </section>
            <div v-else class="no_data"></div>
        </div>
    </v-touch>
</template>

<script>
export default {
    data() {
        return {
            navData: {
                title: '储运日报',
                leftText: '',
                rightText: '',
                leftArrow: true,
                leftCallBack: this.onClickLeft,
            },
            listData: [],
        };
    },
    created() {
        this.listData = JSON.parse(this.$route.query.tableData);
    },
    methods: {
        // 返回上级页面
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/storageAndTransportationDaily', query: {
                date: this.$route.query.date,
            } });
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/storageAndTransportationDaily', query: {
                date: this.$route.query.date,
            } });
        },
    },
};
</script>

<style lang="stylus">
.container
    width 100%
    height 100%
    section
        width 100%
        height 100%
        .list_box1
            width 100%
            margin 12rpx 12rpx 0 12rpx
            table
                width calc(100% - 24rpx)
                border-collapse collapse
                border-color #f4f4f4
                max-height 100%
                thead
                    background #FBEEEE
                .table_body_box
                    height calc(100% - 60rpx)
                    overflow-y scroll
                .head_tr
                    height 44rpx
                    line-height 17rpx
                    .tr_one
                        line-height 40rpx
                tr
                    width 100%
                    display flex
                    border-color #f4f4f4
                    height 36rpx
                    line-height 36rpx
                    th:last-child
                        border-right 1px solid #9d9d9d
                    td:last-child
                        border-right 1px solid #9d9d9d
                    th
                        font-weight 540
                        color #000
                        padding 2rpx
                    th, td
                        width 50%
                        border-color #f4f4f4
                .tr_shallow
                    background #ffffff
                .tr_deep
                    background #F9FAFD
        .list_box
            width 100%
            margin 0 12rpx 12rpx 12rpx
            max-height calc(100% - 136rpx)
            overflow auto
            table
                width calc(100% - 24rpx)
                border-collapse collapse
                border-color #f4f4f4
                thead
                    background #FBEEEE
                .border_div
                    width 100%
                    height 1px
                    background #939393;
                .noData
                    width 100%
                .head_tr
                    height 45rpx
                    line-height 17rpx
                    .tr_one
                        line-height 40rpx
                tr
                    width 100%
                    display flex
                    border-color #f4f4f4
                    th:last-child
                        border-right 1px solid #9d9d9d
                    td:last-child
                        border-right 1px solid #9d9d9d
                    th
                        font-weight 540
                        color #000
                        padding 2rpx
                    th, td
                        width 50%
                        min-height 36rpx
                        border-color #f4f4f4
                        span
                            height: 100%
                            padding 0 5rpx
                            line-height: 16rpx
                            display: flex
                            align-items: center
                            justify-content: center;
                .tr_shallow
                    background #ffffff
                .tr_deep
                    background #F9FAFD
</style>